import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular-ivy";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import packageInfo from 'package.json';

if (environment.production) {
  enableProdMode();
  Sentry.init({
    dsn: "https://5e248bb2f0907e2729f0d02825365003@o392031.ingest.sentry.io/4506559610355712",
    environment: environment.realm,
    release: packageInfo.version,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/server.bdomobile\.com\//],
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, //  Capture 10% of the transactions (reduced from 100% for better performance)
    // Session Replay
    replaysSessionSampleRate: 0.1,
    // This sets the sample rate at 10%.
    replaysOnErrorSampleRate: 1.0,
    // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err: unknown): void => console.error(err));

